import { get, post, del, put } from '@/libs/api.request'
import * as PRODUCT_API from '@/api/product/index'

export default {
  state: {
    productList: [],
    product: null,
    pluginData: {}
  },
  getters: {
    productList: state => state.productList,
    productReferenceQuotesPluginData: (state) => {
      return state.pluginData.quotes
    },
    product: (state) => {
      return state.product
    }
  },
  mutations: {
    setProduct(state, product) {
      state.product = product
    },
    setPluginData(state, { plugin, data }) {
      _.set(state.pluginData, plugin, data)
    },
    setProductList(state, productList) {
      state.productList = productList
    },
    deleteProduct(state, id) {
      const index = state.productList.data.findIndex(product => product.id === id)
      state.productList.data.splice(index, 1)
    }
  },
  actions: {
    emptyProduct ({ commit }, data) {
      commit('setProduct', {})
    },
    getProducts ({ commit }, data) {
      return PRODUCT_API.loadProducts(data).then(res => {
        commit('setProductList', res.data)
        return res
      })
    },
    getProduct ({ commit }, id) {
      return get(`products/${id}`).then(res => {
        commit('setProduct', res.data)
        return res.data
      })
    },
    createProduct ({ commit }, data) {
      return post('products/create', data).then(res => {
        commit('setProduct', res.data)
        return res
      })
    },
    deleteProduct ({ commit }, id) {
      return PRODUCT_API.deleteProduct(id).then(res => {
        commit('deleteProduct', id)
        return res
      })
    },
    updateProduct ({ commit }, data) {
      return put(`products/${data.id}`, data).then(res => {
        commit('setProduct', res.data)
        return res
      })
    },
    getProductReferencePluginData ({ commit }, { plugin, productId }) {
      return PRODUCT_API.getProductReferencePluginData(plugin, productId).then(resp => {
        commit('setPluginData', { plugin: plugin, data: resp.data })
        return resp
      })
    },
    setProductReferencePluginData ({ commit }, { plugin, productId, data }) {
      return PRODUCT_API.setProductReferencePluginData(plugin, productId, data).then(resp => {
        commit('setPluginData', { plugin: plugin, data: resp.data })
        return resp
      })
    },
    deleteProductReferencePluginData ({ commit }, { plugin, productId, data }) {
      return PRODUCT_API.deleteProductReferencePluginData(plugin, productId, data).then(resp => {
        commit('setPluginData', { plugin: plugin, data: data })
        return resp
      })
    },
    /**
     * @deprecated
     *
     * @param {*} param0
     * @param {*} id
     */
    getProductAssociatedBom ({ commit }, id) {
      return get(`products/${id}/associated-boms`).then(res => {
        return res.data
      })
    },
    /**
     * @deprecated
     *
     * @param {*} param0
     * @param {*} param1
     */
    searchProductAssociatedBom ({ commit }, { id, keyword }) {
      return get(`products/${id}/associated-boms/search`, {
        keyword: keyword
      }).then(res => {
        return res.data
      })
    },
    /**
     * @deprecated
     *
     * @param {*} param0
     * @param {*} param1
     */
    addProductAssociatedBom ({ commit }, { id, bom_id }) {
      return post(`products/${id}/associated-boms`, {
        bom_id: bom_id
      }).then(res => {
        return res.data
      })
    },
    /**
     * @deprecated
     *
     * @param {*} param0
     * @param {*} param1
     */
    removeProductAssociatedBom ({ commit }, { id, bom_id }) {
      return del(`products/${id}/associated-boms/${bom_id}`).then(res => {
        return res.data
      })
    },
    /**
     * @deprecated
     *
     * @param {*} param0
     * @param {*} id
     */
    getProductAssociatedPcb ({ commit }, id) {
      return get(`products/${id}/associated-pcbs`).then(res => {
        return res.data
      })
    },
    /**
     * @deprecated
     *
     * @param {*} param0
     * @param {*} param1
     */
    searchProductAssociatedPcb ({ commit }, { id, keyword }) {
      return get(`products/${id}/associated-pcbs/search`, {
        keyword: keyword
      }).then(res => {
        return res.data
      })
    },
    /**
     *  @deprecated
     * @param {*} param0
     * @param {*} param1
     */
    addProductAssociatedPcb ({ commit }, { id, pcb_id }) {
      return post(`products/${id}/associated-pcbs`, {
        pcb_id: pcb_id
      }).then(res => {
        return res.data
      })
    },
    /**
     * @deprecated
     *
     * @param {*} param0
     * @param {*} param1
     */
    removeProductAssociatedPcb ({ commit }, { id, pcb_id }) {
      return del(`products/${id}/associated-pcbs/${pcb_id}`).then(res => {
        return res.data
      })
    }
  }
}
